import { getFramework } from '@/framework';
import type { TextEditorPlugin } from '@/plugins/text-editor';
import type { ILayerBehavior } from '@/version-types';

type Behaviors = Pick<ILayerBehavior, 'exitEditing'>;

/** 创建 Vector Layer 编辑态行为。 */
export const createEditingBehaviors = (identity: string): Behaviors => {
    const framework = getFramework(identity);

    return {
        async exitEditing(layer) {
            const textEditor = framework.service.registration.getInstance<TextEditorPlugin>('TextEditorPlugin');
            if (textEditor?.getSession()?.editingLayer.id !== layer.id) return true;

            await textEditor.exit();
            return textEditor.getSession()?.editingLayer.id !== layer.id;
        },
    };
};
